import React, { useEffect, useState } from "react";
import "./Home.css";

const Home = () => {
  const villageName = "";

  const heroImages = [
    "/images/slider1.jpeg",
    "/images/slider2.jpeg",
    "/images/slider3.jpeg",
    "/images/slider4.jpeg",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  // ===== Leader Data =====

  const sarpanch = {
    name: "श्रीम. मनीषा भारत डोकफोडे",
    phone: 9545174890,
    photo: "/images/sarpanch.jpeg",
  };

  const upsarpanch = {
    name: "श्री सुरेश देव्या दांडेकर",
    photo: "/images/upsarpanch.jpeg",
  };

  // ✅ NEW - सचिव / ग्रामपंचायत अधिकारी
  const sachiv = {
    name: "श्री. सुदेश लहानु कोद्या", // येथे नाव टाका
    photo: "/images/sachiv.jpeg", // public/images मध्ये photo ठेवा
  };

  const members = [
    { sr: 1, name: "श्री. अनिल विठ्ठया घाटाळ", ward: "सदस्य", phone: "7387240330" },
    { sr: 2, name: "श्रीम.स्नेहल सागर घाटाळ", ward: "सदस्य", phone: "7030972018" },
    { sr: 3, name: "श्री. कैलाश पांडुरंग बसवत", ward: "सदस्य", phone: "7620466216" },
    { sr: 4, name: "श्री. राजेश काशिनाथ इभाड", ward: "सदस्य", phone: "7378301087" },
    { sr: 5, name: "श्रीम. संजना सूरज गहला", ward: "सदस्य", phone: "9209202356" },
    { sr: 6, name: "श्री. निलेश काकड्या कामडी ", ward: "सदस्य", phone: "9834059092" },
    { sr: 7, name: "श्रीम. कमल शांताराम डोकफोडे", ward: "सदस्य", phone: "7058602973" },
    { sr: 8, name: "श्रीम. सुनिता सुरेश दांडेकर", ward: "सदस्य", phone: "7798099924" },
    { sr: 9, name: "श्रीम. श्वेता बबन भोईर", ward: "सदस्य", phone: "7448227475" },
    { sr: 10, name: "श्रीम. सुवर्णा कृष्णा डोकफोडे", ward: "सदस्य", phone: "9765548833" },
    { sr: 11, name: "श्री. अंकुश अनंत भोईर", ward: "सदस्य", phone: "9273114254" },
    { sr: 12, name: "श्रीम. पिंकी विनोद बेलकर", ward: "सदस्य", phone: "9284196410" },
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback =
      "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">
      {/* ===== Marquee ===== */}
      <div className="marquee-wrapper">
        <div className="marquee">
          गट ग्रामपंचायत वेती /वरोती | पंचायत समिती डहाणू, जि. पालघर |
          संपर्क:- 9545174890
        </div>
      </div>

      {/* ===== Hero Section ===== */}
      <section className="hero">
        {heroImages.map((img, i) => (
          <div
            key={i}
            className={`hero-slide ${currentSlide === i ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>
              ग्रामपंचायत "वेती /वरोती" आपले स्वागत आहे {villageName}
            </h1>
            <p>आमच्या गावाचा सर्वांगीण विकास हेच आमचे ध्येय!</p>
            <a href="/aboutus">अधिक माहिती</a>
          </div>
        </div>
      </section>

      {/* ===== Leaders Section ===== */}
      <section className="section">
        <h2 className="title">ग्रामपंचायत प्रतिनिधी</h2>
        <div className="layout">
          {/* Leaders Cards */}
          <div className="leaders">

            {/* सरपंच */}
            <div className="leader-card sarpanch-card">
              <div className="leader-img">
                <SafeImage src={sarpanch.photo} alt="सरपंच" />
              </div>
              <h3>सरपंच</h3>
              <b>{sarpanch.name}</b>
            </div>

            {/* उपसरपंच */}
            <div className="leader-card upsarpanch-card">
              <div className="leader-img">
                <SafeImage src={upsarpanch.photo} alt="उपसरपंच" />
              </div>
              <h3>उपसरपंच</h3>
              <b>{upsarpanch.name}</b>
            </div>

            {/* ✅ NEW - सचिव / ग्रामपंचायत अधिकारी */}
            <div className="leader-card sachiv-card">
              <div className="leader-img">
                <SafeImage src={sachiv.photo} alt="सचिव" />
              </div>
              <h3>ग्रामपंचायत अधिकारी</h3>
              <b>{sachiv.name}</b>
            </div>

          </div>

          {/* Members Table */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>सदस्याचे नाव</th>
                  <th>पद</th>
                  <th>संपर्क</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td>{m.name}</td>
                    <td>{m.ward}</td>
                    <td>{m.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ===== Map Section ===== */}
      <section className="map-section">
        <h2 className="map-title">
          📍 गट ग्रामपंचायत वेती /वरोती – स्थान
        </h2>
        <p className="map-subtitle">
          गट ग्रामपंचायत वेती /वरोती, तालुका डहाणू, जिल्हा पालघर
        </p>

        <div className="map-container">
          <iframe
            title="Dahanu Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59996.515231685895!2d72.74564545!3d19.9756597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be727139097994d%3A0x4cdfb0c335cb4ecd!2sDahanu%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1771503660476!5m2!1sen!2sin"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Home;